
import React, { useRef, useEffect, useState } from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import Aboutimage from '../public/about-img1-1.png';
import firstanimation from '../public/animation-video-1.mp4';
import { FaHandsHelping, FaSeedling, FaTruckMoving, FaClipboardList, FaBoxOpen, FaEnvelopeOpenText, FaShippingFast, FaLeaf } from 'react-icons/fa';

const AboutUs = () => {
  const [cartCount, setCartCount] = useState(0);
  const videoRef = useRef(null);


  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener('ended', () => {
        video.play();
      });
      video.play();
    }
    return () => {
      if (video) {
        video.removeEventListener('ended', () => {
          video.play();
        });
      }
    };
  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} />
      <div className="bg-gray-100 py-12 aboutus-font lg:mt-[70px] mt-[130px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-[#154F16] header">About Us</h2>
          </div>
          <div className='grocery-image'>
            <div className='overlay-text'>
              <p className=' text-7xl max-sm:text-5xl'>
                We are a local online grocery start-up that delivers locally in Houston and nationally in the US
              </p>
            </div>
          </div>

          <div className="mb-12 z-10 relative bottom-20 max-sm:bottom-0 px-24 max-sm:px-0">
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <p className="text-gray-700 text-3xl">
                Africfresh, an African online fresh food produce that is delivered locally in Houston, TX and shipped nationally around the country. Africfresh provides convenience with fast delivery processes and At-the-spot delivery of fresh ethnic food produces.
              </p>
            </div>
          </div>

          <div className="video-container mb-12 bg-white flex justify-center items-center py-5 rounded">
            <video ref={videoRef} className="w-[600px]" autoPlay loop muted playsInline>
              <source src={firstanimation} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Step 1 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <FaClipboardList className="text-4xl text-[#154F16] mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Step 1: Order Placement and Delivery Time Selection</h3>
              <p className="text-gray-700">
                Once an order and the appropriate time for delivery is selected.
              </p>
            </div>

            {/* Step 2 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <FaBoxOpen className="text-4xl text-[#154F16] mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Step 2: Order Processing</h3>
              <p className="text-gray-700">
                Our team will get the order packaged, processed, and delivered to the appropriate location of the order.
              </p>
            </div>

            {/* Step 3 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <FaEnvelopeOpenText className="text-4xl text-[#154F16] mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Step 3: Delivery Notification</h3>
              <p className="text-gray-700">
                Once the order is delivered, a notification of your order will be sent out via email, and/or SMS of its completion.
              </p>
            </div>

            {/* Step 4 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <FaShippingFast className="text-4xl text-[#154F16] mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Step 4: Order Tracking</h3>
              <p className="text-gray-700">
                All orders, prior to being delivered, can be tracked on the order page.
              </p>
            </div>

            {/* Step 5 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <FaLeaf className="text-4xl text-[#154F16] mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Step 5: Commitment to Freshness</h3>
              <p className="text-gray-700">
                Africfresh will always deliver the freshest ingredients to our customers, no questions asked!
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;



